import { LogLevel } from '@framework/live2dcubismframework';

export const CanvasSize: { width: number; height: number } | 'auto' = 'auto';
export const CanvasNum = 1;

export const ViewScale = 1.0;
export const ViewMaxScale = 3.0;
export const ViewMinScale = 0.6;

export const ViewLogicalLeft = -1.0;
export const ViewLogicalRight = 1.0;
export const ViewLogicalBottom = -1.0;
export const ViewLogicalTop = 1.0;

export const ViewLogicalMaxLeft = -2.0;
export const ViewLogicalMaxRight = 2.0;
export const ViewLogicalMaxBottom = -2.0;
export const ViewLogicalMaxTop = 2.0;

export const ResourcesPath = './Resources/';
export const ShaderPath = './Framework/Shaders/WebGL/';

export const BackImageName = 'back_class_normal.png';
export const GearImageName = 'icon_gear.png';
export const PowerImageName = 'CloseNormal.png';

export const ModelDir: string[] = [
  "100200_yl",
  "100300_lw",
  "100400_yl",
  "100400_yl_cg",
  "100500_ss",
  "100600_hst",
  "100600_hst_cg",
  "100700_mmr",
  "100800_dd",
  "100900_hst",
  "100900_hst_cg",
  "100901_hst_cg",
  "101000_yz",
  "101000_yz_cg",
  "101001_yz_cg",
  "101001_yz_cg__streamingassets",
  "101100_xdr",
  "101200_bj",
  "101200_bj_cg",
  "101201_bj_cg",
  "101300_yd",
  "101500_djs",
  "101600_zc",
  "101601_zc",
  "101700_yl",
  "101700_yl_cg",
  "101701_yl_cg",
  "102000_mmr",
  "102100_yx",
  "102100_yx_cg",
  "102101_yx",
  "102101_yx_cg",
  "102500_yl",
  "102500_yl_cg",
  "102600_zc",
  "102700_jj",
  "102700_jj_cg",
  "102701_jj_cg",
  "103000_df",
  "103400_dd",
  "103500_txr",
  "103500_txr_cg",
  "103501_txr_cg",
  "103600_dnxb",
  "103600_dnxb_cg",
  "103601_dnxb_cg",
  "103800_tzy",
  "103900_xs",
  "103900_xs_cg",
  "103901_xs",
  "103901_xs_cg",
  "104100_yjs",
  "104600_ls",
  "104900_df",
  "105400_ng",
  "105400_ng_cg",
  "105401_ng_cg",
  "105500_tq",
  "105600_hs",
  "105600_hs_cg",
  "105601_hs_cg",
  "200000_l2d",
  "200001_l2d",
  "200003_l2d",
  "200004_l2d",
  "200007_l2d",
  "200008_l2d",
  "200010_l2d",
  "200011_l2d",
  "200014_l2d",
  "200015_l2d",
  "200017_l2d",
  "200018_l2d",
  "200021_l2d",
  "200025_l2d",
  "200028_l2d",
  "200029_l2d",
  "200030_l2d",
  "200036_l2d",
  "200037_l2d",
  "200038_l2d",
  "200047_l2d",
  "200055_l2d",
  "200071_l2d",
  "200082_l2d",
  "200083_l2d",
  "200084_l2d",
  "200085_l2d",
  "200091_01_l2d",
  "200091_02_l2d",
  "200092_l2d",
  "200093_l2d",
  "200095_l2d",
  "200096_l2d",
  "200099_l2d",
  "200103_l2d",
  "200110_l2d",
  "200112_l2d",
  "200113_l2d",
  "200118_l2d",
  "200124_l2d",
  "200134_l2d",
  "200141_l2d",
  "200146_l2d",
  "200147_l2d",
  "200149_l2d",
  "200151_l2d",
  "200162_l2d",
  "200202_l2d",
  "25100102_yl",
  "25100302_dd",
  "25100702_yl",
  "25100802_jj",
  "25101102_yd",
  "25101302_bj",
  "25101501_sz01",
  "25101502_zc",
  "25102403_xs",
  "600000_nz",
  "7000_petdfl",
  "7001_smedkly",
  "7002_nqhst",
  "7003_nqhst",
  "7005_fsdf",
  "7006_npls",
  "7013_nksbhjl",
  "7016_stlss",
  "7023_ynyl",
  "7031_dfp",
  "7032_nzfq",
  "7033_nzmq",
  "7034_nzdg",
  "7035_nveg",
  "7037_nzsj",
  "7038_dklygg",
  "7039_dklydd",
  "7040_nvmq",
  "7041_mhnh",
  "7042_stqjg",
  "7062_qsl",
  "7064_xewa",
  "7065_mds",
  "7066_alk",
  "7075_wl",
  "7076_jjlt",
  "7082_ttzde",
  "7083_joker2",
  "7084_joker1",
  "7086_njs",
  "7102_dlb",
  "7103_fz",
  "7104_tj",
  "7105_lkdkly",
  "7106_adl",
  "7112_bpr",
  "7113_llshz",
  "7116_cfja",
  "7117_al",
  "7135_bpr"
];
export const ModelDirSize: number = ModelDir.length;

export const MotionGroupIdle = 'Idle';
export const MotionGroupTapBody = 'TapBody';
export const HitAreaNameHead = 'Head';
export const HitAreaNameBody = 'Body';

export const PriorityNone = 0;
export const PriorityIdle = 1;
export const PriorityNormal = 2;
export const PriorityForce = 3;

export const MOCConsistencyValidationEnable = true;
export const MotionConsistencyValidationEnable = true;

export const DebugLogEnable = true;
export const DebugTouchLogEnable = false;
export const CubismLoggingLevel: LogLevel = LogLevel.LogLevel_Verbose;

export const RenderTargetWidth = 1900;
export const RenderTargetHeight = 1000;
